import { render } from "./CRMsource.vue?vue&type=template&id=34e2c7c7&scoped=true"
import script from "./CRMsource.vue?vue&type=script&lang=js"
export * from "./CRMsource.vue?vue&type=script&lang=js"

import "./CRMsource.vue?vue&type=style&index=0&id=34e2c7c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34e2c7c7"

export default script